/* eslint-disable @typescript-eslint/naming-convention */
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TcsNetworkService } from 'src/lib/tcs-network/tcs-network.service';
import { registerIcons, registerSVGIcons } from 'src/util/angular/ng-material-icon-helpers';
import { NewRelicService } from 'src/lib/tcs-new-relic/new-relic-initializer.service';
import { TcsConfigurationService } from './core/configuration.service';
import { PubnubService } from './shared/pubnub/pubnub.service';

const icons = {
  assets: {
    'amgh-logo': '/assets/images/amgh-logo.svg',
    'firstcall-logo': '/assets/images/firstcall-logo.svg',
    'medi-heli': '/assets/images/med-heli-noun_574818_cc.svg',
  },
};

@Component({
  selector: 'tcs-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements AfterViewInit, OnInit, OnDestroy {
  public environment = clientContext.environment;

  get environmentDisplay() {
    return this._tcsConfig.environmentDisplay;
  }

  // For debugging purposes - do not remove
  public clientInfo = {
    clientContext,
    buildEnvironment: environment,
  };

  private _onDestroy$ = new Subject();

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _tcsConfig: TcsConfigurationService,
    private _network: TcsNetworkService,
    private _pubnub: PubnubService,
    private _newRelic: NewRelicService,
    _title: Title,
    // _dialog: MatDialog,
    _router: Router,
    _iconRegistry: MatIconRegistry,
    _domSanitizer: DomSanitizer,
  ) {
    registerIcons(icons, _iconRegistry, _domSanitizer);
    registerSVGIcons(_iconRegistry, _domSanitizer);
  }

  public ngAfterViewInit() {
    this._changeDetectorRef.detectChanges();
  }

  public ngOnInit() {
    this._pubnub.init();
    this._newRelic.init();
  }

  public ngOnDestroy() {
    this._onDestroy$.next(null);
    this._onDestroy$.complete();
  }
}
